import api from "./index";

export const getCustomList = (url, params) => {
  return api.get(url, {params});
}

export const getCount = (url, params) => {
  return api.post(url, params);
}

export const sendMessage = (url, data) => {
  return api.post(url, data);
}

export const getUser = () => {
  return api.get('/user');
}

/**
 * Get cashflow data from API
 * @param {Object} params - Optional query params (startDate, endDate)
 * @returns {Promise} - API response with cashflow rows and summary
 */
export const getCashflow = (params = {}) => {
  return api.get('/cashflow', {params});
}